// // import React from "react";
// // import Container from "@mui/material/Container";
// // import Box from "@mui/material/Box";

// // export default function AuthLayout({ children }) {
// //   return (
// //     <Container maxWidth="sm">
// //       <Box
// //         sx={{
// //           minHeight: "100vh",
// //           display: "flex",
// //           alignItems: "center",
// //         }}
// //       >
// //         <Box sx={{ width: "100%" }}>{children}</Box>
// //       </Box>
// //     </Container>
// //   );
// // }
// // src/components/AuthLayout.jsx
// import React from "react";
// import Box from "@mui/material/Box";
// import Container from "@mui/material/Container";
// import Paper from "@mui/material/Paper";

// export default function AuthLayout({ children, backgroundImage }) {
//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         backgroundImage: `url(${backgroundImage})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         p: 2,
//       }}
//     >
//       <Container maxWidth="sm">
//         <Paper
//           elevation={6}
//           sx={{
//             p: { xs: 3, sm: 5 },
//             borderRadius: 3,
//             backdropFilter: "blur(6px)",
//             backgroundColor: "rgba(255,255,255,0.8)",
//           }}
//         >
//           {children}
//         </Paper>
//       </Container>
//     </Box>
//   );
// }

// src/components/AuthLayout.jsx
import React from "react";
import { Box, Container, Paper, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import authBgDesktop from "../assets/auth-bg-desktop.png";
import authBgMobile from "../assets/auth-bg-mobile.png";
import logo from "../assets/Logo.png";

export default function AuthLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: `url(${isMobile ? authBgMobile : authBgDesktop})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 2, sm: 4 },
      }}
    >

    {/* ✅ Logo Positioned Over Background */}
      {/* ✅ Logo Positioned Responsively */}
      <Box
        component="img"
        src={logo}
        alt="Logo"
        sx={{
          position: "absolute",
          zIndex: 1,
          opacity: 0.95,
          // ✅ Increased logo size and made it scale responsively
            height: {
              xs: "115px",  // mobile (was 70px)
              sm: "135px", // tablet (was 90px)
              md: "150px", // desktop (was 120px)
              lg: "180px", // large screens — extra bump
            },

          // Desktop: centered within left half
          ...(isMobile
            ? {
                top: { xs: "40px", sm: "20px" }, // ⬅️ slightly lower only on xs,
                left: "50%",
                transform: "translateX(-50%)",
              }
            : {
                top: "50%",
                left: "25%",
                transform: "translate(-50%, -50%)",
              }),
        }}
      />

      {/* ✅ Main Auth Content */}
      <Container maxWidth="sm">
        {/* <Paper
          elevation={6}
          sx={{
            p: { xs: 3, sm: 5 },
            borderRadius: 3,
            // backdropFilter: "blur(8px)",
            // backgroundColor: "rgba(255,255,255,0.85)",
            backgroundColor: "rgba(255, 255, 255, 0.12)", // white with slight transparency
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            backdropFilter: "blur(8px)", // adds subtle glass effect
          }}
        >
          {children}
        </Paper> */}
        <Paper
          elevation={6}
          sx={{
            p: { xs: 3, sm: 5 },
            borderRadius: 3,
            zIndex: 3 ,
            position: 'relative',
            backgroundColor: {
              xs: 'transparent', // mobile (<=600px)
              sm: 'rgba(255, 255, 255, 0.08)', // tablet and above
            },
            boxShadow: {
              xs: 'none',
              sm: '0 8px 32px rgba(0,0,0,0.2)',
            },
            backdropFilter: {
              xs: 'none',
              // sm: 'blur(8px)',
            },
            // border: 1 solid rgba(255, 255, 255, 0.18),
            // border: '1.5px solid #BC965E',
            border: {
              xs: "none", // remove border below 600px
              sm: "1.5px solid #BC965E", // show border at 600px and above
            },

          }}
        >
          {children}
        </Paper>
      </Container>

      {/* Footer */}
      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          bottom: { xs: 10, sm: 14 },
          left: 0,
          right: 0,
          textAlign: "center",
          color: "#fff",
          fontSize: { xs: "0.8rem", sm: "0.95rem" },
          fontWeight: 600,
          letterSpacing: 1,
          pointerEvents: "none",
          userSelect: "none",
        }}
      >
        Developed By H M IT Solutions
      </Typography>
    </Box>
  );
}
